import WhatsApp from "js/components-v2/pages/SellerSignup/WhatsApp";
import SteppedComponent from 'js/components/pages/SteppedComponent';
import { lightGrey1Color } from 'js/config/style';
import { validPrice } from 'js/services/Regex';
import CreateNewPaymentLinkPageState from "js/stores/pages/CreateNewPaymentLinkPageState";
import { observer } from 'mobx-react';
import React from "react";
import ItemDetails from './ItemDetails';
import PickupDetails from './PickupDetails';
import SizeDetails from './SizeDetails';
import ShareCheckout from "./ShareCheckout";
import Congratulations from "./Congratulations";

@observer
export default class CreateNewPaymentLinkPage extends SteppedComponent {
  fileUpload = React.createRef();
  pageName = 'CreateNewPaymentLinkPage';
  trackingName = 'SP_create_link';
  pageColor = lightGrey1Color;
  pageWidth = '1200px';

  constructor(props) {
    super(props);
    this.state = {
      step1: 1,
      step2: 0,
      step3: 0,
      catalog: [],
      requestInProgress: 0,
      errorMessage: null,
    };

    this.page = CreateNewPaymentLinkPageState.create().setSteps(this, 'create-new-payment-link-page', [
      {
        name: 'item',
        label: 'Item',
        component: ItemDetails,
        completed: paymentLink => !!(paymentLink.title && validPrice(page.price)),
        onEnter: () => { /*analytics.page('PLC_viewed item Info')*/ },
        showStepMenu: false,
      },
      {
        name: 'size',
        label: 'Size',
        component: SizeDetails,
        completed: paymentLink => !!paymentLink.size,
        onEnter: () => { /*analytics.page('PLC_viewed item size')*/ },
        showStepMenu: false,
      },
      {
        name: 'pickup-details',
        label: 'Pick-up details',
        component: PickupDetails,
        isComplete: (page, step) => page.address.hasAddress,
        onEnter: () => { /*analytics.page('PLC_viewed pickup address')*/ },
        showStepMenu: true,
      },
      {
        name: 'congratulations',
        label: 'Congratulations',
        component: Congratulations,
        onEnter: (page, step) => { /*analytics.page('PLC_viewed sign up step')*/ },
      },
      {
        name: 'whatsapp',
        label: 'WhatsApp',
        component: WhatsApp,
        onEnter: (page, step) => { /*analytics.page('PLC_viewed sign up step')*/ },
      },
      {
        name: 'share-checkout',
        label: 'Share checkout link',
        component: ShareCheckout,
        onEnter: (page, step) => { /*analytics.page('PLC_viewed sign up step')*/ },
      },
    ]);

    const params = new URLSearchParams(window.location.search);

    if (params.has('name')) {
      this.page.setTitle(params.get('name'));
    }
  }
}
